import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface ConfirmationDialogData {
  message: string;
  tag: string;
}

@Component({
  selector: 'app-tag-confirmation-dialog',
  template: `
    <div class="dialog-container">
      <h2 mat-dialog-title>Remove Tag</h2>
      <mat-dialog-content>
        <p>{{data.message}}</p>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="null">
          Cancel
        </button>
        <button mat-button [mat-dialog-close]="'remove'" color="primary">
          Remove from Item
        </button>
        <button mat-button [mat-dialog-close]="'delete'" color="warn">
          Delete from Database
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .dialog-container {
      padding: 20px;
      min-width: 320px;
    }
    h2 {
      margin: 0 0 16px 0;
      font-size: 20px;
      font-weight: 500;
    }
    p {
      margin: 0 0 20px 0;
      color: rgba(0, 0, 0, 0.7);
      font-size: 16px;
      line-height: 1.5;
    }
    mat-dialog-actions {
      padding: 0;
      margin: 0;
      display: flex;
      gap: 8px;
      justify-content: flex-end;
    }
  `],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class TagConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TagConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {}
} 